module.exports = __webpack_public_path__ + "files/c2d63580d81c479093aef738f033ca1b.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-bold-webfont.eot
// module id = 331
// module chunks = 60